import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import productionService from "../services/production.service";
import { setMessage } from "./message";

export const fetchProductionList = createAsyncThunk(
    'diePress/fetchProductionList',
    async ({ page, pagesize, search, ordering,shift,press,start_date,end_date }, thunkAPI) => {
        try {
            const response = await productionService.getProductionList(page, pagesize, search, ordering,shift,press,start_date,end_date);
            return response.data; // Assuming response contains { data: { users, totalpage, etc. }}
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);


export const createProduction = createAsyncThunk(
    'production/createProduction',
    async (payload, thunkAPI) => {
        try {
            const response = await productionService.createProduction(payload);
            return response.data; // Assuming response contains the created category data
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const fetchProductionById = createAsyncThunk(
    'diePress/fetchProductionById',
    async ({ id, page, pagesize, search, ordering }, thunkAPI) => {
        try {
            const response = await productionService.getProductionById(id, page, pagesize, search, ordering);
            return response; // Assuming response contains { data: { users, totalpage, etc. }}
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);



export const editProduction = createAsyncThunk(
    'production/editProduction',
    async ({ id, payload }, thunkAPI) => {
        try {
            const response = await productionService.editProduction(id, payload);
            return response.data; // Ensure this returns the updated category data
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);


const initialState = {
    data: [],
    list: [],
    loading: false,
    totalpage: 0,
    currentpage: 1,
    totalRecord: 0,
    status: 'idle',
    error: null,
    hasMore: true,
};

const productionSlice = createSlice({
    name: 'diePress',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchProductionList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchProductionList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentpage;
                state.data = action.payload.results.data || [];  // Update to match your API response
                state.totalRecord = action.payload.count || 0; // Handle count (total records)
                state.totalPages = action.payload.totalPages || 0; // Handle totalPages
                state.totaldie = action.payload.total_die_count || 0;
                state.totaltool = action.payload.total_die_tool_count || 0;
                state.currentpage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchProductionList.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });

        builder
            .addCase(createProduction.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(createProduction.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.loading = true;
            })
            .addCase(createProduction.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.payload;
            });

        builder
            .addCase(fetchProductionById.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchProductionById.fulfilled, (state, action) => {
                state.loading = false;
                state.activeProfileRecord = action.payload;
            })
            .addCase(fetchProductionById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });

        builder
            .addCase(editProduction.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(editProduction.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const index = state.data.findIndex(category => category.id === action.payload.id);
                if (index !== -1) {
                    state.loading = true;
                    state.data[index] = action.payload;
                }
            }).addCase(editProduction.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.payload;
            });
    },
});
const { reducer } = productionSlice;
export default reducer;
